import React, {memo} from "react";
import {Grid, Paper, Typography} from "@material-ui/core";
import {connect} from "react-redux";
import moment from "moment";
import AutorenewIcon from "@material-ui/icons/Autorenew";
import {useConfig} from "../../context/configContext";
import theme from "./styles";
import translate from "../../misc/applyTranslation";

const Header = props => {
  const {refreshN8n, lastUpdateTime} = props;

  const config = useConfig();
  const classes = theme(config);

  return (
    <Paper elevation={0} className={classes.paper}>
      <Grid container spacing={2}>
        <Grid item xs={6} className={classes.headerLeftCol}>
          <div>
            <Typography variant="h6" component="h2">{translate('n8n', 'header_title')}</Typography>
            <Typography variant="subtitle2" component="h6">
              {translate('n8n', 'header_sub_title')}
            </Typography>
          </div>
        </Grid>
        <Grid item xs={6} className={classes.headerRightCol}>
          <Typography variant="subtitle2" component="span">{`${translate('n8n', 'header_last_update_label')}: ${moment(lastUpdateTime).format("HH:mm:ss")}`}</Typography>
          <AutorenewIcon onClick={refreshN8n}/>
        </Grid>
      </Grid>
    </Paper>
  )
}

const mapStateToProps = store => ({
  access_token: store.login.access_token,
});

export default connect(mapStateToProps)(memo(Header));